import React from 'react';
import { IDSButton } from '@inera/ids-react';

/**
 * Generic confirmation dialog.
 *
 * Defaults to the delete wording it originally had, so existing call sites keep
 * working unchanged. Pass `title`, `confirmLabel` and `cancelLabel` to reuse it
 * for other irreversible actions.
 */
const ConfirmDialog = ({
  isOpen = true,
  message,
  onConfirm,
  onCancel,
  title = 'Bekräfta borttagning',
  confirmLabel = 'Ja, ta bort',
  cancelLabel = 'Nej',
  confirmDisabled = false,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2000,
      }}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div style={{
        background: 'white', padding: '2rem', borderRadius: '8px',
        maxWidth: '420px', width: '90%',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
      }}>
        <h2 className="ids-heading-m" style={{ marginBottom: '1rem' }}>{title}</h2>
        {message && <p style={{ marginBottom: '1.5rem', color: '#333' }}>{message}</p>}
        {children}
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <IDSButton secondary size="m" type="button" onClick={onCancel}>
            {cancelLabel}
          </IDSButton>
          <IDSButton size="m" type="button" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmLabel}
          </IDSButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
